import {
  CsvExportDefinition,
  formatMillisecondsDateTime
} from "../../../common/csvExport";

export type DataExportRecord = {
  id: string | number;
  createdAt?: string | number;
  createdBy?: { email?: string };
  startMonth?: string;
  endMonth?: string;
  status?: string;
  dataExportSha256?: string;
};

export const dataExportExportDefinition: CsvExportDefinition<DataExportRecord> =
  {
    resource: "DataExport",
    filenameStem: "data-export-history",
    id: { header: "dataExportID", source: "id" },
    columns: [
      {
        key: "createdAt",
        source: "createdAt",
        label: "Created At",
        // buildQueryDataExport normalizes Carrot Graph seconds to milliseconds.
        getValue: (record) => formatMillisecondsDateTime(record.createdAt)
      },
      {
        key: "createdBy.email",
        source: "createdBy.email",
        label: "By",
        getValue: (record) => record.createdBy?.email || ""
      },
      {
        key: "startMonth",
        source: "startMonth",
        label: "Start Month",
        getValue: (record) => record.startMonth || ""
      },
      {
        key: "endMonth",
        source: "endMonth",
        label: "End Month",
        getValue: (record) => record.endMonth || ""
      },
      {
        key: "status",
        source: "status",
        label: "Status",
        getValue: (record) => record.status || ""
      },
      {
        key: "dataExportSha256",
        source: "dataExportSha256",
        label: "SHA256",
        getValue: (record) => record.dataExportSha256 || ""
      }
    ]
  };
